import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from "react";
import { Alert, Button, ButtonToolbar, Icon, Preloader } from "@icg360/ui-toolkit";
import postPolicyChangeSet from "../../promises/postPolicyChangeSet";
import { PRELOAD, LOADING, LOADED, LOAD_ERROR } from "../../constants";
import { formFieldPropTypes, pacDataPropTypes } from "../../shared/propTypes";
import { filterChangedFieldsForCopy } from "../../shared/utils";
import styles from "./Saved.styles";
import { array } from "prop-types";

var Saved = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Saved, _Component);

  function Saved(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.getChangedFieldsSummary = function () {
      var derivedForm = _this.props.derivedForm;
      return filterChangedFieldsForCopy(derivedForm);
    };

    _this.handleDone = function () {
      var _this$props$pacData = _this.props.pacData,
          handleExternalClose = _this$props$pacData.handleExternalClose,
          policyActionSavedCallback = _this$props$pacData.policyActionSavedCallback;
      if (typeof policyActionSavedCallback === "function") policyActionSavedCallback();
      if (handleExternalClose) handleExternalClose();
    };

    _this.handleCopy = function () {
      var changedFields = _this.getChangedFieldsSummary().join('\n');

      navigator.clipboard.writeText(changedFields).then(function () {
        _this.setState({
          didCopy: true
        });

        setTimeout(function () {
          _this.setState({
            didCopy: false
          });
        }, 3000);
      }).catch(function (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      });
      ;
    };

    _this.state = {
      loadState: PRELOAD,
      didCopy: false
    };
    return _this;
  } // Note:
  // If the user closed the Pac UI while *saving* a request, the attachment
  // and/or note will never end up getting posted (as this component will
  // never mount). If this edge case needs to be solved, it should be solved on
  // the server where the server accepts everything at once (the
  // <TransactionRequest> along with the note and/or attachment). Then
  // we won't be in this weird position where maybe only *some* of the
  // users request got saved.


  var _proto = Saved.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _this$props = this.props,
        attachment = _this$props.attachment,
        note = _this$props.note,
        pacData = _this$props.pacData; // Only proceed if there is an attachment or note

    if (attachment.value || note.value) {
      this.setState({
        loadState: LOADING
      });
      postPolicyChangeSet({
        attachment: attachment.value,
        note: note.value,
        pacData: pacData
      }).then(function () {
        _this2.setState({
          loadState: LOADED
        });
      }).catch(function (err) {
        // eslint-disable-next-line no-console
        console.error("Error uploading note and/or attachment.", err);

        _this2.setState({
          loadState: LOAD_ERROR
        });
      });
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        attachment = _this$props2.attachment,
        note = _this$props2.note,
        showCopyChangedFields = _this$props2.pacData.showCopyChangedFields;
    var _this$state = this.state,
        loadState = _this$state.loadState,
        didCopy = _this$state.didCopy;
    var hasAttachment = Boolean(attachment.value);
    var hasNote = Boolean(note.value);
    var changedFields = this.getChangedFieldsSummary();
    var label = "";

    if (hasAttachment && hasNote) {
      label = "attachment and note";
    } else if (hasAttachment) {
      label = "attachment";
    } else if (hasNote) {
      label = "note";
    }

    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Alert, {
      bsStyle: "success"
    }, /*#__PURE__*/React.createElement("strong", null, "Success:"), " changes have been processed. Refresh the policy to see the most recent changes."), showCopyChangedFields && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      style: styles.bold
    }, "Summary:"), changedFields.map(function (field, i) {
      return /*#__PURE__*/React.createElement("p", {
        key: i
      }, field);
    })), (hasAttachment || hasNote) && /*#__PURE__*/React.createElement("div", {
      style: styles.messageContainer
    }, loadState === LOADING && /*#__PURE__*/React.createElement("div", {
      style: styles.message
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.iconContainer
    }, /*#__PURE__*/React.createElement(Preloader, {
      size: 24
    })), "Uploading ", label, "..."), loadState === LOADED && /*#__PURE__*/React.createElement("div", {
      style: styles.message,
      className: "text-success"
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.iconContainer
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "check",
      style: styles.icon
    })), "Successfully added the ", label, " to the policy."), loadState === LOAD_ERROR && /*#__PURE__*/React.createElement("div", {
      style: styles.message,
      className: "text-danger"
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.iconContainer
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "clear",
      style: styles.icon
    })), /*#__PURE__*/React.createElement("div", null, "There was a problem uploading the ", label, "."))), /*#__PURE__*/React.createElement(ButtonToolbar, {
      className: "pull-right"
    }, showCopyChangedFields && /*#__PURE__*/React.createElement(Button, {
      onClick: this.handleCopy
    }, didCopy ? "Copied!" : "Copy Summary"), /*#__PURE__*/React.createElement(Button, {
      onClick: this.handleDone
    }, "Done")));
  };

  return Saved;
}(Component);

Saved.propTypes = {
  attachment: formFieldPropTypes.isRequired,
  note: formFieldPropTypes.isRequired,
  pacData: pacDataPropTypes,
  derivedForm: array
};
export { Saved as default };